<template>
  <v-row align="center" no-gutters>
    <v-col cols="12" md="6" offset-md="3">
      <v-text-field
        v-model="user.email"
        label="Enter User's Email"
        color="secondary"
        outlined
      >
      </v-text-field>
    </v-col>
    <v-col cols="12" md="6" offset-md="3">
      <v-row no-gutters>
        <v-col cols="6" class="text-left">
          <v-btn outlined @click="$emit('close')" small color="red darken-3">
            <v-icon left>fas fa-times</v-icon>
            Cancel
          </v-btn>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn outlined @click="createUser()" small :disabled="!user.email">
            <v-icon left>fas fa-angle-double-right</v-icon>
            Create User
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    data(){
      return {
        user : {
          email : "",
          pass  : Math.random().toString().slice(-6)
        }
      }
    },
    methods: {
      createUser(){
        this.$store.dispatch('createUser', this.user)
        this.$emit('close')
      }
    }
  }
</script>
